/* eslint-disable */

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

import * as Actions from './async-actions';
import * as Fetch from './fetch';

export interface GetProductActivityRequest {
	productActivityTypes: number[];
	userIds: number[];
	blueprintIds: number[];
	supplierProductNumber: string;
	unitMeasureCodes: string[];
	days: number | null;
	skip: number;
	take: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductActivityResponse {
	productActivities: ProductActivity[];
	activityTypes: number[];
	blueprints: IdAndName[];
	users: IdAndName[];
	unitMeasureCodes: string[];
	totalResults: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductActivity {
	productActivityType: number;
	userId: number;
	userName: string;
	blueprintId: number;
	blueprintExists: boolean;
	blueprintName: string;
	metaProductId: number;
	metaProductExists: boolean;
	metaProductName: string;
	supplier: string;
	supplierProductNumber: string;
	supplierProductDescription: string;
	unitMeasureCode: string;
	occurredAt: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface IdAndName {
	id: number;
	name: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface File {
	contentType: string;
	contentDisposition: string;
	headers: IHeaderDictionary;
	length: number;
	name: string;
	fileName: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface IHeaderDictionary {
	item: StringValues;
	contentLength: number | null;
	accept: StringValues;
	acceptCharset: StringValues;
	acceptEncoding: StringValues;
	acceptLanguage: StringValues;
	acceptRanges: StringValues;
	accessControlAllowCredentials: StringValues;
	accessControlAllowHeaders: StringValues;
	accessControlAllowMethods: StringValues;
	accessControlAllowOrigin: StringValues;
	accessControlExposeHeaders: StringValues;
	accessControlMaxAge: StringValues;
	accessControlRequestHeaders: StringValues;
	accessControlRequestMethod: StringValues;
	age: StringValues;
	allow: StringValues;
	altSvc: StringValues;
	authorization: StringValues;
	baggage: StringValues;
	cacheControl: StringValues;
	connection: StringValues;
	contentDisposition: StringValues;
	contentEncoding: StringValues;
	contentLanguage: StringValues;
	contentLocation: StringValues;
	contentMD5: StringValues;
	contentRange: StringValues;
	contentSecurityPolicy: StringValues;
	contentSecurityPolicyReportOnly: StringValues;
	contentType: StringValues;
	correlationContext: StringValues;
	cookie: StringValues;
	date: StringValues;
	eTag: StringValues;
	expires: StringValues;
	expect: StringValues;
	from: StringValues;
	grpcAcceptEncoding: StringValues;
	grpcEncoding: StringValues;
	grpcMessage: StringValues;
	grpcStatus: StringValues;
	grpcTimeout: StringValues;
	host: StringValues;
	keepAlive: StringValues;
	ifMatch: StringValues;
	ifModifiedSince: StringValues;
	ifNoneMatch: StringValues;
	ifRange: StringValues;
	ifUnmodifiedSince: StringValues;
	lastModified: StringValues;
	link: StringValues;
	location: StringValues;
	maxForwards: StringValues;
	origin: StringValues;
	pragma: StringValues;
	proxyAuthenticate: StringValues;
	proxyAuthorization: StringValues;
	proxyConnection: StringValues;
	range: StringValues;
	referer: StringValues;
	retryAfter: StringValues;
	requestId: StringValues;
	secWebSocketAccept: StringValues;
	secWebSocketKey: StringValues;
	secWebSocketProtocol: StringValues;
	secWebSocketVersion: StringValues;
	secWebSocketExtensions: StringValues;
	server: StringValues;
	setCookie: StringValues;
	strictTransportSecurity: StringValues;
	tE: StringValues;
	trailer: StringValues;
	transferEncoding: StringValues;
	translate: StringValues;
	traceParent: StringValues;
	traceState: StringValues;
	upgrade: StringValues;
	upgradeInsecureRequests: StringValues;
	userAgent: StringValues;
	vary: StringValues;
	via: StringValues;
	warning: StringValues;
	webSocketSubProtocols: StringValues;
	wWWAuthenticate: StringValues;
	xContentTypeOptions: StringValues;
	xFrameOptions: StringValues;
	xPoweredBy: StringValues;
	xRequestedWith: StringValues;
	xUACompatible: StringValues;
	xXSSProtection: StringValues;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface StringValues {
	count: number;
	item: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NewMassImportRequestResponse {
	id: number;
	customerId: number;
	supplierId: number;
	userId: number;
	customerName: string;
	massImportRequestStatusId: MassImportRequestStatus;
	blueprintId: number | null;
	createdAt: string;
	updatedAt: string;
	applyChanges: boolean | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGroupingSavingsResponse {
	totalNewSavings: number;
	totalImplementedSavings: number;
	totalStagedSavings: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductsWithItemsRequest {
	metaProductIds: number[];
	blueprintId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductsWithItemsResponse {
	metaProducts: GetMetaProductResponse[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductResponse {
	id: number;
	name: string;
	blueprintName: string;
	search: string;
	maintainedBy: MaintainedBy;
	statusId: MetaProductStatus;
	selectionRuleSetId: number;
	specIndicatorId: number | null;
	pendingRebuild: boolean;
	customCategoryId: number | null;
	productHeaders: ProductHeader[];
	products: ProductWithUM[];
	distributionCenterOverrides: DistributionCenterOverride[];
	isSelectByUm: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductHeader {
	corpSupplierCode: string;
	supplierProductNumber: string;
	unitMeasureCodes: string[];
	activeDistributionCenters: DistributionCenterWithUMs[];
	coveredDistributionCenters: DistributionCenterWithUMs[];
	description: string;
	extendedDescription: string;
	brand: string;
	hasBrandFlag: boolean;
	packSize: string;
	conversionQuantity: number;
	hasDemand: boolean;
	hasRemote: boolean;
	hasNonStock: boolean;
	proprietary: number;
	categoryLevel1: string;
	categoryLevel1Code: string;
	categoryLevel2: string;
	categoryLevel2Code: string;
	categoryLevel3: string;
	categoryLevel3Code: string;
	categoryLevel4: string;
	categoryLevel4Code: string;
	hasPermutations: boolean;
	specIndicatorId: number | null;
	hasPhaseOutReplacement: boolean;
	remoteStockDcs: DistributionCenterWithUMs[];
	demandStockDcs: DistributionCenterWithUMs[];
	nonstockDcs: DistributionCenterWithUMs[];
	productAlertDcs: DistributionCenterWithUMs[];
	glGroup: GlGroup;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DistributionCenterWithUMs {
	distributionCenter: string;
	unitMeasureCodes: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GlGroup {
	id: string;
	groupId: number;
	bUType: number;
	description: string;
	gLOverride: string;
	defaultAccount: GLAccount;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GLAccount {
	account: string;
	description: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductWithUM {
	corpSupplierCode: string;
	supplierProductNumber: string;
	unitMeasureCode: string;
	specIndicatorId: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DistributionCenterOverride {
	supplierProductNumber: string;
	unitMeasureCode: string;
	distributionCenterId: number;
	overrideType: OverrideType;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductGroupingInformationPostBody {
	blueprintId: number;
	sourceMetaProductIds: number[];
	outputGroupingIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductGroupingInformationResponse {
	metaProducts: GetMetaProductResponse[];
	metaProductGroupings: MetaProductGrouping[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductGrouping {
	id: number;
	groupedMetaProductId: number;
	statusId: MetaProductGroupingStatus;
	source: MetaProductGroupingSource;
	createdAt: string;
	stagedAt: string | null;
	projectedSavings: number;
	feedbackSetId: number | null;
	lastGrouped: string | null;
	removes: MetaProductGroupingRemove[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductGroupingRemove {
	sourceMetaProductId: number;
	productNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpsertMetaProductGroupingsPostBody {
	blueprintId: number;
	source: MetaProductGroupingSource;
	isSelectByUm: boolean;
	requests: UpsertMetaProductGroupingRequest[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpsertMetaProductGroupingRequest {
	metaProductGroupingId: number | null;
	newMetaProductName: string;
	metaProductGroupingRemoves: MetaProductGroupingRemove[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpsertGroupingsResponse {
	responses: UpsertGroupingResponse[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpsertGroupingResponse {
	groupingId: number;
	groupedMetaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CalculateCurrentMetaProductCoveragesArgs {
	metaProductIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CalculateCurrentMetaProductCoveragesResult {
	metaProductCoverages: MetaProductCoverage[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductCoverage {
	metaProductId: number;
	totalDistributionCenters: number | null;
	coveredDistributionCenters: number | null;
	isOpenSpecItemInCurrentChoices: boolean | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GenerateGroupingRecommendationRequest {
	products: ProductWithUM[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GenerateGroupingRecommendationResult {
	productGroupings: ProductGrouping[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductGrouping {
	groupLabel: string;
	products: ProductIdentifier[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductIdentifier {
	supplierProductNumber: string;
	unitOfMeasure: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ZendeskResponse {
	widgetToken: string;
	widgetUrl: string;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ResultSet<T> {
	errors: string[];
	results: T[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface BlueprintListing {
	locationCount: number;
	metaProductCount: number;
	id: number;
	name: string;
	createdAt: string;
	updatedAt: string;
	supplier: Supplier;
	supplierId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Supplier {
	id: number;
	name: string;
	dssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintsRequest {
	pageSize: number;
	pageIndex: number;
	supplierId: number;
	searchTerm: string;
	locationIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SupplierGroupArgs {
	corpSupplierDssiCode: string;
	supplierProductNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetNumberOfBlueprintsContainingProductsResult {
	results: BlueprintCounts[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface BlueprintCounts {
	productNumber: string;
	corpSupplierCode: string;
	blueprintCount: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintsProductIsOnForCustomerRequest {
	supplierId: number;
	supplierProductNumber: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintsProductIsOnForCustomerResult {
	results: GetBlueprintsProductIsOnForCustomerResponse[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintsProductIsOnForCustomerResponse {
	id: number;
	name: string;
	customerId: number;
	supplierId: number;
	createdAt: string;
	updatedAt: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetDistributionCenterInfoResult {
	results: DistributionCenter[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DistributionCenter {
	id: number;
	name: string;
	externalCode: string;
	dssiCode: string;
	supplierId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ChangedLocations {
	removedLocationIds: number[];
	addedLocationIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintDefaultMetaProductMaintainedByResult {
	maintainedBy: MaintainedBy;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CustomCategory {
	id: number;
	customerId: number;
	category: string;
	categorySequence: number;
	isDefault: boolean;
	metaProductCount: number;
	pendingDelete: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CustomerAdminListing {
	id: number;
	nationalId: string;
	name: string;
	locationCount: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateCustomerItemNumbersRequestObject {
	supplierId: number;
	customerItemNumbers: CustomerItemNumberMapping[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CustomerItemNumberMapping {
	supplierProductNumber: string;
	customerItemNumber: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateCustomerItemNumbersResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCustomerItemNumberInfoRequestObject {
	supplierId: number;
	supplierProductNumber: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCustomerItemNumberInfoResult {
	customerItemNumber: string;
	description: string;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetDiscontinuedAlertsResult {
	alerts: ResultSet<DiscontinuedAlert>;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ResultSet<T> {
	errors: string[];
	results: T[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DiscontinuedAlert {
	id: number;
	supplierId: number;
	supplierProductNumber: string;
	unitMeasureCodes: string[];
	metaProductId: number;
	metaProductName: string;
	blueprintId: number;
	blueprintName: string;
	metaProductItemId: number;
	distributionCenterId: number;
	distributionCenterName: string;
	productDescription: string;
	productBrand: string;
	packSize: string;
	productDiscontinuedAt: string;
	productAddedToMetaProductAt: string | null;
	wasCoverageLost: boolean | null;
	wasBoosted: boolean;
	lastOrderedAt: string | null;
	quantityOrdered: number | null;
	isContracted: boolean | null;
	createdAt: string;
	lastUpdatedAt: string;
	isPendingAdditionalData: boolean;
	totalDistributionCenters: number | null;
	coveredDistributionCenters: number | null;
	isOpenSpecItemInCurrentChoices: boolean | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface BulkDeleteDiscontinuedAlertsArgs {
	alertIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteDiscontinuedAlertsResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlGroupsResult {
	glGroups: GlGroup[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GlGroup {
	id: string;
	groupId: number;
	bUType: number;
	description: string;
	gLOverride: string;
	defaultAccount: GLAccount;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GLAccount {
	account: string;
	description: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlGroupsErrorResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlGroupsForProductsArgs {
	productsWithDcs: ProductWithDcs[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductWithDcs {
	productNumber: string;
	distributionCenters: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlGroupsForProductsResult {
	glGroups: GetGlGroupsForProductsResult_GlGroup[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlGroupsForProductsResult_GlGroup {
	productNumber: string;
	glGroup: GlGroup;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlAccountsForGlGroupResult {
	accounts: GlAccountAndDescription[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GlAccountAndDescription {
	account: string;
	description: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGlAccountsForGlGroupErrorResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AssignGLAccountArgs {
	supplierId: number;
	productNumber: string;
	glGroupId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AssignGlGroupErrorResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface LocationAndFilterResponse {
	locations: EnabledLocation[];
	states: string[];
	suppliers: Supplier[];
	dcNumbers: string[];
	dcNames: string[];
	cities: string[];
	totalNumLocations: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EnabledLocation {
	enabled: boolean;
	id: number;
	customerId: number;
	name: string;
	bidlistDescription: string;
	overrideDescription: string;
	restrictionDescription: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	locationCode: string;
	externalCode: string;
	distributionCenterExternalCode: string;
	distributionCenterName: string;
	distributionCenterDssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Supplier {
	id: number;
	name: string;
	dssiSupplierCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AcceptMetaProductGroupPostBody {
	metaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AcceptAllMetaProductGroupPostBody {
	metaProductGroupingIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface StageMetaProductGroupPostBody {
	metaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductGroupsPostBody {
	groupingIds: number[];
	metaProductIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductGroupingsResponse {
	groupings: MetaProductGrouping[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteMetaProductsArgs {
	blueprintId: number;
	metaProductIds: number[];
	filterText: string;
	hasCoverageAlerts: boolean;
	hasPhaseOuts: boolean;
	metaProductSpecIndicators: number[];
	metaProductItemSpecIndicators: number[];
	customCategoryIds: number[];
	maintainedBys: MaintainedBy[];
	pageIndex: number;
	pageSize: number;
	stockTypes: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteMetaProductsResult {
	nextPageIndex: number;
	nextMetaProducts: ResultSet<MetaProductStatistics>;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ResultSet<T> {
	errors: string[];
	results: T[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductStatistics {
	id: number;
	name: string;
	search: string;
	blueprintId: number;
	itemCount: number;
	locationAvailability: number;
	distributionCenterAvailability: number;
	isSelectByUm: boolean;
	pendingRebuild: boolean;
	specIndicatorId: number | null;
	maintainedBy: MaintainedBy;
	statusId: MetaProductStatus;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteMetaProductArgs {
	blueprintId: number;
	metaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteMetaProductResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SearchMetaProductGroupingArgsV6 {
	metaProductIds: number[];
	statusIds: number[];
	sourceIds: number[];
	startDate: string | null;
	endDate: string | null;
	customerId: number;
	blueprintIds: number[];
	distributionCenterId: number | null;
	searchTerm: string;
	notGroupedAfter: string | null;
	pageSize: number;
	pageIndex: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductGroupingResult {
	lastUpdated: string;
	errors: string[];
	results: MetaProductGroupingSummaryLine[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductGroupingSummaryLine {
	id: number;
	metaProductId: number;
	status: MetaProductGroupingStatus;
	source: MetaProductGroupingSource;
	removes: MetaProductGroupingRemove[];
	orderGuideId: number;
	orderGuideName: string;
	firstMasterItemId: number | null;
	firstMasterItem: string;
	groupedCount: number;
	supplierProductCount: number;
	projectedSavings: number;
	stagedAt: string | null;
	lastGrouped: string | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductChoicesGivenProductsAndSelectionRuleSetRequest {
	blueprintId: number;
	selectionRuleSetId: number;
	metaProductItems: MetaProductItemWithOverride[];
	isSelectByUm: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductItemWithOverride {
	productNumber: string;
	unitMeasureCode: string;
	itemOrder: number;
	distributionCenterOverrides: DistributionCenterOverride[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetMetaProductChoicesGivenProductsAndRuleSetResponse {
	metaProductChoicesByDc: MetaProductChoicesByDc[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductChoicesByDc {
	distributionCenterId: number;
	products: MetaProductItemNumberAndUM[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductItemNumberAndUM {
	supplierProductNumber: string;
	unitMeasureCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductsMaintainedByPostBody {
	blueprintId: number;
	metaProductIds: number[];
	maintainedBy: MaintainedBy;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MetaProductsCustomCategoryPostBody {
	customCategoryId: number;
	blueprintId: number;
	metaProductIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetAIHistoryRequest {
	searchTerm: string;
	orderGuideFilters: number[];
	distributionCenterFilters: number[];
	historyType: HistoryType | null;
	startDate: string | null;
	endDate: string | null;
	dateFilter: string;
	page: number;
	status: OptimizationStatus | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetAIHistoryResults {
	data: AIHistoryData[];
	totalResults: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AIHistoryData {
	historyType: HistoryType;
	histId: number;
	id: number;
	blueprintId: number;
	blueprintName: string;
	blueprintIsActive: boolean;
	metaProductId: number;
	metaProductName: string;
	metaProductIsActive: boolean;
	differenceCount: number;
	wasBoosted: boolean;
	savings: number | null;
	date: string;
	wasManual: boolean;
	itemData: AIItemSnapshotData[];
	optimizationStatus: OptimizationStatus | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AIItemSnapshotData {
	supplierId: number;
	supplierProductNumber: string;
	itemName: string;
	brand: string;
	packSize: string;
	productUms: AIItemSnapshotProductUm[];
	wasAddition: boolean;
	distributionCentersImpacted: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AIItemSnapshotProductUm {
	unitOfMeasure: string;
	minPrice: number | null;
	maxPrice: number | null;
	minPricePerUnit: number | null;
	maxPricePerUnit: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteAIHistoryResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetAIHistoryFiltersRequest {
	orderGuideFilters: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetAIHistoryFiltersResult {
	orderGuideFilters: AIHistoryFilterOption[];
	distributionCenterFilters: AIHistoryFilterOption[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AIHistoryFilterOption {
	label: string;
	value: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationSuggestionsRequest {
	orderGuideIds: number[];
	status: OptimizationStatus | null;
	searchTerm: string;
	pageIndex: number;
	notOptimizedAfter: string | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationSuggestionsResult {
	lastUpdated: string;
	suggestions: OptimizationSuggestion[];
	totalResults: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OptimizationSuggestion {
	optimizationId: number;
	stagedAt: string | null;
	orderGuideId: number;
	orderGuideName: string;
	masterItemId: number;
	masterItemName: string;
	impactedDcCount: number;
	totalDcCount: number;
	projectedSavings: number;
	status: OptimizationStatus;
	invalidationReason: string;
	lastOptimized: string | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationSavingsResult {
	totalNewSavings: number;
	newCount: number;
	totalImplementedSavings: number;
	totalStagedSavings: number;
	stagedCount: number;
	annualProjected90DaySavings: number;
	annualProjectedYearSavings: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationSuggestionFiltersResult {
	orderGuideFilters: OrderGuideFilter[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OrderGuideFilter {
	name: string;
	id: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationDetailsArgs {
	metaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOptimizationDetailsResult {
	optimizationDetails: OptimizationDetail;
	staleOptimizationDetails: OptimizationDetail;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OptimizationDetail {
	optimizationId: number;
	optimizationStatus: OptimizationStatus;
	masterItemName: string;
	masterItemId: number;
	corpSupplierCode: string;
	optimizationCoveredDcCount: number;
	totalDcCount: number;
	masterOrderGuideName: string;
	masterOrderGuideId: number;
	numberOfUnaffectedProducts: number;
	products: OptimizationDetailProduct[];
	netUnitProducts: ProductNetUnits[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OptimizationDetailProduct {
	type: OptimizationDetailType;
	impactedDcCount: number;
	totalDcCount: number;
	productName: string;
	extendedDescription: string;
	productNumber: string;
	brand: string;
	packSize: string;
	unitMeasures: OptimizationDetailProductUnitMeasure[];
	projectedSavings: number | null;
	hasBrandFlag: boolean | null;
	isCatchweightItem: boolean;
	isContract: boolean;
	dcDetails: OptimizationDetailDCInformation[];
	supplierId: number;
	status: OptimizationItemStatus | null;
	supplierCategoryLevel1Description: string;
	supplierCategoryLevel2Description: string;
	supplierCategoryLevel3Description: string;
	supplierCategoryLevel4Description: string;
	supplierCategoryLevel1Code: string;
	supplierCategoryLevel2Code: string;
	supplierCategoryLevel3Code: string;
	supplierCategoryLevel4Code: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OptimizationDetailProductUnitMeasure {
	unitOfMeasure: string;
	netUnits: number | null;
	netUnitType: NetUnitType | null;
	maxPrice: number | null;
	minPrice: number | null;
	maxPricePerUnit: number | null;
	minPricePerUnit: number | null;
	usage: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OptimizationDetailDCInformation {
	willAddCoverage: boolean;
	dcName: string;
	productNumber: string;
	productName: string;
	extendedDescription: string;
	brand: string;
	packSize: string;
	usage: number | null;
	isContract: boolean;
	hasBrandFlag: boolean | null;
	hasRebateFlag: boolean | null;
	supplierId: number;
	isOriginalCatchweightItem: boolean;
	isReplacementCatchweightItem: boolean;
	originalUnitMeasures: OptimizationDetailProductUnitMeasure[];
	replacementUnitMeasures: OptimizationDetailProductUnitMeasure[];
	supplierCategoryLevel1Description: string;
	supplierCategoryLevel2Description: string;
	supplierCategoryLevel3Description: string;
	supplierCategoryLevel4Description: string;
	supplierCategoryLevel1Code: string;
	supplierCategoryLevel2Code: string;
	supplierCategoryLevel3Code: string;
	supplierCategoryLevel4Code: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductNetUnits {
	corpSupplierCode: string;
	productNumber: string;
	unitOfMeasure: string;
	productName: string;
	packSize: string;
	netUnits: number | null;
	netUnitType: NetUnitType | null;
	isCatchweightItem: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyOptimizationsRequest {
	requests: ApplyOptimizationArgs[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyOptimizationArgs {
	optimizationId: number;
	rejectedOptimizationItemIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyOptimizationsResult {
	appliedOptimizationIds: number[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyOptimizationByMasterItemArgs {
	productFeedback: ProductFeedbackCreationArgs[];
	metaProductId: number;
	rejectedReplacementSupplierProductNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductFeedbackCreationArgs {
	supplierProductNumber: string;
	accepted: boolean;
	acceptedBrand: boolean;
	acceptedDescription: boolean;
	acceptedPackSize: boolean;
	acceptedCustomerPreference: boolean;
	otherFeedback: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyOptimizationByMasterItemResult {
	appliedMetaProductId: number | null;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface StageOptimizationByMasterItemArgs {
	productFeedback: ProductFeedbackCreationArgs[];
	metaProductId: number;
	rejectedReplacementSupplierProductNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface StageOptimizationByMasterItemResult {
	stagedMetaProductId: number | null;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeclineOptimizationByMasterItemArgs {
	productFeedback: ProductFeedbackCreationArgs[];
	metaProductId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeclineOptimizationByMasterItemResult {
	declinedMetaProductId: number | null;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OverrideNetUnitsArgs {
	requests: OverrideNetUnitRequest[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OverrideNetUnitRequest {
	corpSupplierCode: string;
	supplierProductNumber: string;
	unitMeasureCode: string;
	netUnits: number;
	netUnitType: NetUnitType;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface OverrideNetUnitsResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateOptimizationItemNetUnitsArgs {
	metaProductId: number;
	requests: UpdateOptimizationItemNetUnitsRequest[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateOptimizationItemNetUnitsRequest {
	supplierProductNumber: string;
	unitMeasureCode: string;
	netUnits: number;
	netUnitType: NetUnitType;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateOptimizationItemNetUnitsResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteOptimizationResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RecalculateOptimizationArgs {
	metaProductId: number;
	suggestAdditionalProducts: boolean;
	applyAutomatically: boolean;
	additionalProducts: Product[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Product {
	supplierProductNumber: string;
	unitMeasureCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RecalculateOptimizationResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface InProgressRecalculateOptimizationResult {
	inProgress: boolean;
	timeSent: string | null;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductHeaderPricesResult {
	errors: string[];
	prices: ProductHeaderPrices[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductHeaderPrices {
	productNumber: string;
	corpSupplierCode: string;
	prices: ProductPriceRange[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductPriceRange {
	min: number | null;
	max: number | null;
	minPerUnit: number | null;
	maxPerUnit: number | null;
	netMin: number | null;
	netMax: number | null;
	netMinPerUnit: number | null;
	netMaxPerUnit: number | null;
	netUnitSource: NetUnitSource | null;
	catchWeightPriceMin: number | null;
	catchWeightPriceMax: number | null;
	catchWeightNetPriceMin: number | null;
	catchWeightNetPriceMax: number | null;
	catchWeightPriceMultiplierMin: number | null;
	catchWeightPriceMultiplierMax: number | null;
	catchWeightPriceDescription: string;
	unitOfMeasure: string;
	unitDivisor: number | null;
	perUnit: string;
	isContractPriced: boolean;
	displayAsAudited: boolean;
	rebates: ProductRebate[];
	rebateRange: ProviderProductRebateRange;
	netUnitsType: NetUnitType | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductRebate {
	rebateType: string;
	value: number | null;
	descriptiveUM: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProviderProductRebateRange {
	rebateMin: number | null;
	rebateMax: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SupplierProductIdentifier {
	corpSupplierCode: string;
	supplierProductNumber: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductLinePrices {
	distributionCenterDssiCode: string;
	supplierProductNumber: string;
	productPrices: ProductPrice[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductPrice {
	distributionCenterDssiCode: string;
	unitOfMeasure: string;
	price: number | null;
	pricePerUnit: number | null;
	netPrice: number | null;
	netPricePerUnit: number | null;
	unitDivisor: number | null;
	netUnitSource: NetUnitSource | null;
	perUnit: string;
	catchWeightPrice: number | null;
	catchWeightNetPrice: number | null;
	catchWeightPriceMultiplier: number | null;
	catchWeightPriceDescription: string;
	rebate: ProductRebateDetails;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductRebateDetails {
	contractCustomerId: number;
	starRebateType: number;
	rebateValue: number;
	productRebate: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MassChangeHomeResult {
	canStartNewMassChange: boolean;
	requests: MassChangeHomeResult_MassChangeRequest[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface MassChangeHomeResult_MassChangeRequest {
	id: number;
	createdAt: string;
	createdBy: string;
	supplierName: string;
	status: string;
	addOrDelete: MassChangeRequestType;
	itemCount: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductInputPageDataResult {
	suppliers: GetProductInputPageDataResult_Supplier[];
	canStartNewMassChange: boolean;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductInputPageDataResult_Supplier {
	corpSupplierCode: string;
	name: string;
	id: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface VerifyProductsArgs {
	itemNumbers: string[];
	supplierId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface VerifyProductsResult {
	items: VerifyProductsResult_Item[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface VerifyProductsResult_Item {
	supplierProductNumber: string;
	itemDescription: string;
	unitsOfMeasure: string[];
	brand: string;
	isValid: boolean;
	isActive: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectMasterOrderGuidesDataArgs {
	customerId: number | null;
	supplierId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectMasterOrderGuidesDataResult {
	masterOrderGuides: SelectMasterOrderGuidesDataResult_MasterOrderGuide[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectMasterOrderGuidesDataResult_MasterOrderGuide {
	id: number;
	name: string;
	supplierId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectBlueprintsDataMultSuppliersArgs {
	customerId: number | null;
	supplierIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ReviewChangesArgs {
	supplierId: number;
	blueprintIds: number[];
	itemNumbers: string[];
	addOrDelete: MassChangeRequestType;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ReviewChangesResult {
	massChangeRequestId: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface PollRequestStatusArgs {
	massChangeRequestId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface PollRequestStatusResult {
	isStaged: boolean;
	blueprints: PollRequestStatusResult_Blueprint[];
	addOrDelete: MassChangeRequestType;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface PollRequestStatusResult_Blueprint {
	name: string;
	changeCount: number;
	noActionCount: number;
	items: PollRequestStatusResult_BlueprintItem[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface PollRequestStatusResult_BlueprintItem {
	supplierProductNumber: string;
	itemDescription: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyChangesArgs {
	massChangeRequestId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ApplyChangesResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DiscardChangesArgs {
	massChangeRequestId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DiscardChangesResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface LookupResult {
	results: SearchResultItem[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SearchResultItem {
	id: string;
	corpSupplierCode: string;
	supplierProductNumber: string;
	unitMeasureCodes: string[];
	description: string;
	extendedDescription: string;
	brand: string;
	packSize: string;
	activeDistributionCenters: DistributionCenterWithUMs[];
	coveredDistributionCenters: DistributionCenterWithUMs[];
	hasBrandFlag: boolean;
	hasDemand: boolean;
	hasRemote: boolean;
	hasNonStock: boolean;
	hasPermutations: boolean;
	nonstockDcs: DistributionCenterWithUMs[];
	remoteStockDcs: DistributionCenterWithUMs[];
	demandStockDcs: DistributionCenterWithUMs[];
	propDcs: DistributionCenterWithUMs[];
	supplierCategoryLevel1Code: string;
	supplierCategoryLevel2Code: string;
	supplierCategoryLevel3Code: string;
	supplierCategoryLevel4Code: string;
	supplierCategoryLevel1Description: string;
	supplierCategoryLevel2Description: string;
	supplierCategoryLevel3Description: string;
	supplierCategoryLevel4Description: string;
	proprietaryEligibleDcs: DistributionCenterWithUMs[];
	proprietaryDcs: DistributionCenterWithUMs[];
	hasPhaseOutReplacement: boolean;
	conversionQuantity: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductLinesResult {
	productLines: ProductLineDetails[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductLineDetails {
	corpSupplierCode: string;
	distributionCenterName: string;
	distributionCenterDssiCode: string;
	status: string;
	manufacturerProductNumber: string;
	supplierProductNumber: string;
	isProprietary: boolean;
	unitMeasureCodes: string[];
	isEligible: boolean;
	isDemand: boolean;
	isRemote: boolean;
	isNonstock: boolean;
	isBranded: boolean;
	distributionCenterDisplayCode: string;
	phaseOutReplacementProductHeader: ProductHeader;
	product: Product;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Product {
	corpSupplierCode: string;
	supplierProductNumber: string;
	specIndicatorId: number | null;
	hasPhaseOutReplacement: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductDetails {
	errors: string[];
	supplierCode: string;
	thirdLineDescription: string;
	productNumber: string;
	images: string[];
	gtin: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductNutritionalInformationParams {
	productNumber: string;
	supplierCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NutritionResponse {
	errors: string[];
	productNumber: string;
	supplierCode: string;
	contains: string[];
	mayContain: string[];
	freeFrom: string[];
	dietType: string[];
	organicClaims: string[];
	addedSugarInGrams: number | null;
	calciumInMg: number | null;
	calories: number | null;
	caloriesFromFat: number | null;
	carbohydratesInGrams: number | null;
	cholesterolInMg: number | null;
	fatInGrams: number | null;
	fiberInGrams: number | null;
	folateInMcg: number | null;
	ironInMg: number | null;
	monounsaturatedFatInGrams: number | null;
	niacinInMg: number | null;
	potassiumInMg: number | null;
	proteinInGrams: number | null;
	riboflavinInMg: number | null;
	saturatedFatInGrams: number | null;
	sodiumInMg: number | null;
	thiaminInMg: number | null;
	totalSugarInGrams: number | null;
	transFatInGrams: number | null;
	vitaminAInMcg: number | null;
	vitaminCInMg: number | null;
	vitaminDInMcg: number | null;
	servingSizeQuantity: number[];
	nutritionAllergenResponse: NutritionAllergenResponse[];
	nutritionDietaryTypeResponse: NutritionDietaryTypeResponse;
	nutritionOrganicClaimsResponse: NutritionOrganicClaimsResponse;
	disclaimer: string;
	ingredientList: string;
	name: string;
	servingSizeDescription: string;
	servingsPerContainer: string;
	servingSizeUnit: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NutritionAllergenResponse {
	allergenName: string;
	allergenCode: NutritionAllergenResponseCode;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NutritionAllergenResponseCode {
	contains: boolean;
	derivedFrom: boolean;
	freeFrom: boolean;
	mayContain: boolean;
	notDerivedFrom: boolean;
	notIntentionallyIncluded: boolean;
	undeclared: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NutritionDietaryTypeResponse {
	isCoeliac: boolean;
	isDietetic: boolean;
	isFreeFromGluten: boolean;
	isHalal: boolean;
	isKosher: boolean;
	isOrganic: boolean;
	isVegan: boolean;
	isVegetarian: boolean;
	isWithoutBeef: boolean;
	isWithoutPork: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NutritionOrganicClaimsResponse {
	bioDynamic: boolean;
	disqualified: boolean;
	inConversion: boolean;
	madeWithOrganicIngredients: boolean;
	notOrganic: boolean;
	oneHundredPercentOrganic: boolean;
	organic: boolean;
	someOrganicIngredients: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductUsageArgs {
	products: Product[];
	blueprintId: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Product {
	productNumber: string;
	chSupplier: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductUsageResult {
	productUsages: ProductUsage[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductUsage {
	productNumber: string;
	chSupplier: string;
	unitOfMeasure: string;
	lastPurchasedOrderNumber: string;
	lastPurchasedOrderQuantity: number;
	lastPurchasedOrderDate: string | null;
	quantityOrderedSinceTimeProvided: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetProductUsageErrorResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetGeneratedReportsResult {
	results: ReportRow[];
	totalResults: number;
	totalPages: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ReportRow {
	reportId: number;
	customerId: number;
	customerName: string;
	reportType: number;
	createdAt: string;
	downloadLink: string;
	rowCount: number;
	displaySuffix: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetRequestableReportsResult {
	reportRequests: ReportRequestRow[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ReportRequestRow {
	reportTypeId: number;
	reportRequestId: number;
	customerId: number;
	reportRequestStatusId: number;
	userName: string;
	userId: number;
	createdAt: string;
	updatedAt: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOrderGuideReportArgs {
	customerId: number;
	supplierId: number;
	locationIds: number[];
	distributionCenterIds: number[];
	masterOrderGuideIds: number[];
	splitReportByDc: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOrderGuideReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestStockMatrixReportArgs {
	customerId: number;
	supplierIds: number[];
	locationIds: number[];
	distributionCenterIds: number[];
	masterOrderGuideIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestStockMatrixReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiHistoryReportArgs {
	dateFilter: string;
	orderGuideFilters: string[];
	distributionCenterFilter: string;
	searchTerm: string;
	startDate: string | null;
	endDate: string | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiHistoryReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiOptimizationsReportArgs {
	blueprintIds: number[];
	status: OptimizationStatus | null;
	searchTerm: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiOptimizationsReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiGroupingsReportArgs {
	customerId: number;
	blueprintIds: number[];
	searchTerm: string;
	status: MetaProductGroupingStatus | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Nullable<T> {
	hasValue: boolean;
	value: T;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiGroupingsReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiCombinedReportArgs {
	customerId: number;
	blueprintIds: number[];
	optimizationStatus: OptimizationStatus | null;
	groupingStatus: MetaProductGroupingStatus | null;
	searchTerm: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOgmAiCombinedReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NewReportRequestArgs {
	customerId: number;
	reportTypeId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface NewReportRequestResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestLocationLevelPricingReportArgs {
	supplierId: number;
	supplierProductNumber: string;
	unitOfMeasure: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestLocationLevelPricingReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface IsLocationLevelPricingEnabledResponse {
	locationLevelPricingEnabled: boolean;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOffOrderGuideSavingsReportArgs {
	startDate: string | null;
	endDate: string | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RequestOffOrderGuideSavingsReportResult {
	reportRequestRow: ReportRequestRow;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetRestrictionListingResult {
	lists: RestrictionList[];
	totalCount: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RestrictionList {
	id: number;
	name: string;
	supplier: RestrictionSupplier;
	locationCount: number;
	productCount: number;
	ruleCount: number;
	subunitIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RestrictionSupplier {
	id: number;
	name: string;
	dssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetNewListPageDataResult {
	suppliers: RestrictionSupplier[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CreateRestrictionListArgs {
	supplierId: number;
	name: string;
	subunitIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CreateRestrictionListResult {
	restrictionListId: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetRestrictionListResult {
	restrictionListName: string;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EditRestrictionListArgs {
	listId: number;
	newName: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EditRestrictionListResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteRestrictionListArgs {
	restrictionListId: number;
	pageSize: number;
	pageIndex: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteRestrictionListResult {
	errors: string[];
	lists: RestrictionList[];
	totalCount: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCategoryRulesPageDataResult {
	errors: string[];
	listName: string;
	supplierName: string;
	categories: Category[];
	rules: Rule[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Category {
	id: number;
	title: string;
	isParent: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Rule {
	categoryId: number;
	restrictionState: RestrictionState;
	title: string;
	restrictionMessage: string;
	parentPath: ParentPath[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ParentPath {
	categoryId: number;
	categoryLevel: number;
	title: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetSubCategoriesResult {
	errors: string[];
	categories: Category[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SaveCategoryRulesArgs {
	restrictionListId: number;
	rules: CategoryRestrictionRule[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CategoryRestrictionRule {
	categoryId: number;
	restrictionState: RestrictionState;
	restrictionMessage: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SaveCategoryRulesResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetLocationListingResult {
	locations: LocationListing[];
	restrictionListName: string;
	supplierName: string;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface LocationListing {
	locationId: number;
	locationName: string;
	distributionCenterName: string;
	currentListName: string;
	isSelected: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateRestrictionListLocationLinksArgs {
	restrictionListId: number;
	locationIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateRestrictionListLocationLinksResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetItemRestrictionPageArgs {
	restrictionListId: number;
	searchTerm: string;
	skip: number;
	take: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetItemRestrictionPageResult {
	listName: string;
	supplierName: string;
	items: ItemRestriction[];
	totalResults: number;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ItemRestriction {
	productNumber: string;
	message: string;
	description: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RemoveItemRestrictionsArgs {
	restrictionListId: number;
	productNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RemoveItemRestrictionsResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CheckProductNumbersArgs {
	restrictionListId: number;
	baseSupplierProductNumbers: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CheckProductNumbersResult {
	errors: string[];
	validations: ProductNumberValidation[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductNumberValidation {
	productNumber: string;
	description: string;
	isValid: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AddItemRestrictionsArgs {
	restrictionListId: number;
	items: ItemRestrictionArg[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ItemRestrictionArg {
	baseSupplierProductNumber: string;
	message: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface AddItemRestrictionsResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetNumberOfRestrictionListsContainingProductsArgs {
	corpSupplierDssiCode: string;
	supplierProductNumber: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetNumberOfRestrictionListsContainingProductsResult {
	results: ProductWithRestrictionsListCount[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ProductWithRestrictionsListCount {
	productNumber: string;
	corpSupplierCode: string;
	restrictionsListCount: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetRestrictionListsProductIsOnForCustomerArgs {
	supplierProductNumber: string;
	supplierCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetRestrictionListsProductIsOnForCustomerResult {
	productRestrictionLists: RestrictionsListIdAndName[];
	categoryRestrictionLists: RestrictionsListIdAndName[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface RestrictionsListIdAndName {
	id: number;
	name: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SearchRequestObject {
	searchTerm: string;
	skip: number;
	limit: number;
	corpSupplierCodesFilter: string[];
	distributionCentersFilter: string[];
	blueprintId: number | null;
	brandFilter: string;
	packSizeFilter: string;
	packSizeFilters: string[];
	categoryLevel1Filter: string;
	categoryLevel2Filter: string;
	categoryLevel3Filter: string;
	categoryLevel4Filter: string;
	allowedStockTypes: StockType[];
	includeOnlyEligibleItems: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SearchResult {
	results: ResultSet<SearchResultItem>;
	supplierFacet: SearchFacet[];
	categoryLevel1Facet: SearchFacet[];
	categoryLevel2Facet: SearchFacet[];
	categoryLevel3Facet: SearchFacet[];
	categoryLevel4Facet: SearchFacet[];
	brandFacet: SearchFacet[];
	packSizeFacet: SearchFacet[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ResultSet<T> {
	errors: string[];
	results: T[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SearchFacet {
	displayString: string;
	filterTerm: string;
	documentCount: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CreateInvoiceSequenceArgs {
	customerId: number;
	chartName: string;
	secondarySequence: SecondarySequence;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CreateInvoiceSequenceResult {
	invoiceSequence: InvoiceSequenceHeader;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface InvoiceSequenceHeader {
	id: number;
	customerId: number;
	chartName: string;
	distributionCenterIds: number[];
	draftId: number | null;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteInvoiceSequenceDraftResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetInvoiceSequenceForCustomerIdResult {
	invoiceSequences: InvoiceSequenceHeader[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateDistributionCentersAssociatedToInvoiceSequenceArgs {
	distributionCenterIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateAssociatedDistributionCentersResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetOrCreateInvoiceSequenceDraftResult {
	draft: InvoiceSequenceData;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface InvoiceSequenceData {
	id: number;
	secondarySequence: SecondarySequence;
	invoiceCategories: InvoiceCategory[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface InvoiceCategory {
	id: number | null;
	supplierCategoryIds: number[];
	productNumbers: string[];
	sequenceNumber: number;
	firstDescription: string;
	secondDescription: string;
	glCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateInvoiceSequenceDraftArgs {
	data: InvoiceSequenceData;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateInvoiceSequenceDraftResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SubmitInvoiceSequenceDraftResult {
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetTopLevelCategoriesResult {
	errors: string[];
	categories: CategoryRow[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CategoryRow {
	id: number;
	code: string;
	description: string;
	isParent: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetSubLevelCategoriesResult {
	errors: string[];
	categories: CategoryRow[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCategoryAndParentsArgs {
	categoryIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCategoryAndParentsResult {
	categories: CategoryRowWithParentId[];
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface CategoryRowWithParentId {
	parentId: number | null;
	id: number;
	code: string;
	description: string;
	isParent: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Supplier {
	supplierId: number;
	supplierName: string;
	dssiSupplierCode: string;
	id: number;
	name: string;
	dssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetEditCustomerPageResult {
	errors: string[];
	customerId: number;
	customerName: string;
	nationalId: string;
	isFullCustom: boolean;
	isSysco12Default: boolean;
	hasAutoPhaseOut: boolean;
	hasDailyRefresh: boolean;
	hasSpecIndicator: boolean;
	hasSyncPropItems: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SaveCustomerAttributesArgs {
	customerId: number;
	hasAutoPhaseOut: boolean;
	hasDailyRefresh: boolean;
	hasSpecIndicator: boolean;
	hasSyncPropItems: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SaveCustomerAttributesResult {
	errors: string[];
	customerId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EnableCustomCategorySettingArgs {
	customerId: number;
	isSysco12Default: boolean;
	isFullCustom: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EnableCustomCategorySettingResult {
	errors: string[];
	customerId: number;
	isFullCustom: boolean;
	isSysco12Default: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetLocationsForCustomerRequest {
	customerId: number;
	pageIndex: number;
	pageSize: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface ResultSet<T> {
	errors: string[];
	results: T[];
	totalResults: number;
	totalPages: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface LocationAdminListing {
	id: number;
	customerId: number;
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	locationCode: string;
	externalCode: string;
	distributionCenter: DistributionCenterAdmin;
	charts: Chart[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DistributionCenterAdmin {
	id: number;
	name: string;
	externalCode: string;
	dssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Chart {
	id: number;
	distributionCenterId: number;
	name: string;
	description: string;
	chartType: ChartType;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface BlueprintStatistics {
	locationCount: number;
	metaProductCount: number;
	distributionCenterCount: number;
	id: number;
	name: string;
	supplierId: number;
	supplierProvidesRTA: boolean;
	createdAt: string;
	updatedAt: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintDistributionCenterLinkForCustomerAndMultipleSuppliersArgs {
	customerId: number;
	supplierIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetBlueprintDistributionCenterLinkForCustomerAndMultipleSuppliersResponse {
	blueprintDistributionCenterLinks: BlueprintDistributionCenterLink[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface BlueprintDistributionCenterLink {
	supplierId: number;
	blueprintId: number;
	distributionCenterId: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface Customer {
	id: number;
	name: string;
	dssiCode: string;
	attributes: CustomerAttribute[];
	selectionRuleSets: SelectionRuleSet[];
	customerIsExternal: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectionRuleSet {
	id: number;
	name: string;
	displayToken: string;
	isDefault: boolean;
	selectionRules: SelectionRule[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface SelectionRule {
	rule: SelectionRuleType;
	ruleOrder: number;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetCustomerNoteResults {
	customerId: number;
	customerNote: string;
	errors: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface UpdateCustomerNoteArgs {
	customerNote: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetLocationsForCustomerAndMultipleSuppliersArgs {
	customerId: number;
	supplierIds: number[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetLocationsForCustomerAndMultipleSuppliersResponse {
	locations: FullLocation[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface FullLocation {
	customerId: number;
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	externalCode: string;
	id: number;
	locationCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetDistributionCenterCodesForSupplierResponse {
	distributionCenterDssiCodes: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetDistributionCentersByDssiCodesArgs {
	distributionCenterDssiCodes: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetDistributionCentersByDssiCodesResponse {
	distributionCenters: DistributionCenter[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface GetUSFoodsProductAttributesArgs {
	supplierProductNumbers: string[];
	distributionCenterDssiCodes: string[];
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface USFoodsProductAttributes {
	supplierProductNumber: string;
	distributionCenterDssiCode: string;
	isCulinary: boolean;
	isJustInTime: boolean;
	isKosher: boolean;
	isSeasonal: boolean;
	isSpecialty: boolean;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface EnabledLocation {
	id: number;
	customerId: number;
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	locationCode: string;
	externalCode: string;
	enabled: boolean;
	distributionCenterExternalCode: string;
	distributionCenterName: string;
	distributionCenterDssiCode: string;
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export interface DeleteSyscoLocationsRequest {
	customerId: number;
	locationIds: number[];
}

export enum MassImportRequestStatus {
	Pending = 1,
	InProgress = 2,
	Completed = 3,
	Error = 4,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum MaintainedBy {
	OGM3 = 1,
	OGMAIAuto = 2,
	OGMAIManual = 3,
	AutoRepriorize = 4,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum MetaProductStatus {
	Active = 1,
	Draft = 2,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum OverrideType {
	Boost = 1,
	Exclude = 2,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum MetaProductGroupingStatus {
	New = 1,
	Applied = 2,
	Rejected = 3,
	Staged = 4,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum MetaProductGroupingSource {
	User = 1,
	Machine = 2,
	Ai = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum HistoryType {
	Combined = 1,
	Optimization = 2,
	Grouping = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum OptimizationStatus {
	New = 1,
	Staged = 2,
	Accepted = 3,
	Declined = 4,
	Invalidated = 5,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum OptimizationDetailType {
	New = 0,
	Boost = 1,
	Deprioritize = 2,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum NetUnitType {
	oz = 1,
	count = 2,
	in = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum OptimizationItemStatus {
	New = 1,
	StagingDeclined = 2,
	Accepted = 3,
	CustomerDeclined = 4,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum NetUnitSource {
	PART = 1,
	Override = 2,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum MassChangeRequestType {
	Add = 1,
	Delete = 2,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum RestrictionState {
	Restricted = 1,
	Unrestricted = 2,
	Inherit = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum StockType {
	Stocked = 0,
	Demand = 1,
	Remote = 2,
	NonStock = 3,
	Unknown = 4,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum SecondarySequence {
	Supc = 1,
	Description = 2,
	ItemSequence = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum ChartType {
	BidList = 1,
	RestrictionList = 2,
	ItemOverrideList = 3,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum CustomerAttribute {
	ExternalCustomer = 1,
	SyncProprietaryItems = 2,
	SyncDiscrepancies = 3,
	SpecIndicator = 4,
	AutoAddPhaseOutItems = 5,
	CustomCategories = 6,
	SyscoSyncSplits = 7,
	Sysco12Default = 9,
	OgmAi = 10,
}

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================

export enum SelectionRuleType {
	UserDefinedOrder = 1,
	Stocked = 2,
	Demand = 3,
	Remote = 4,
	NonStock = 5,
	LeadTime = 6,
	ExcludeDemand = 7,
	ExcludeRemote = 8,
	ExcludeNonStock = 9,
}

export const ActivityController = {
	GetProductActivity: (request: GetProductActivityRequest) => {
		const uri = `/api/v4/activity/product`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(request),
		};
		return Fetch.fetch2<GetProductActivityResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const MassImportRequestController = {
	GetMassImportTemplateDownload: () => {
		const uri = `/api/v4/massimportrequests/download/massimporttemplate`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<string>(config);
	},

	GetBulkApplyMassImportTemplateDownload: () => {
		const uri = `/api/v4/massimportrequests/download/bulkapplymassimporttemplate`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<string>(config);
	},

	GetMassCustomerItemNumberImportTemplateDownload: () => {
		const uri = `/api/v4/massimportrequests/download/massCustomerItemNumberImportTemplate`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<string>(config);
	},

	IsMassImportInProgress: (customerId: number) => {
		const uri = `/api/v4/massimportrequests/massimportinprogress?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<boolean>(config);
	},

	IsMassCustomerItemNumberImportInProgress: (customerId: number) => {
		const uri = `/api/v4/massimportrequests/massimportinprogress/customerItemNumber?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<boolean>(config);
	},

	NewMassImportRequest: (formData: FormData) => {
		const uri = `/api/v4/massimportrequests/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: formData,
		};
		return Fetch.fetch2<NewMassImportRequestResponse>(config);
	},

	NewBulkApplyMassImportRequest: (formData: FormData) => {
		const uri = `/api/v4/massimportrequests/BulkApply`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: formData,
		};
		return Fetch.fetch2<NewMassImportRequestResponse>(config);
	},

	NewMassCustomerItemNumberImportRequest: (formData: FormData) => {
		const uri = `/api/v4/massimportrequests/CustomerItemNumber`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: formData,
		};
		return Fetch.fetch2<NewMassImportRequestResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const MetaProductControllerV4 = {
	GetGroupingSavings: () => {
		const uri = `/api/v4/metaproducts/group/savings`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
		};
		return Fetch.fetch2<GetGroupingSavingsResponse>(config);
	},

	GetMetaProductsWithItems: (request: GetMetaProductsWithItemsRequest) => {
		const uri = `/api/v4/metaproducts/batch`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(request),
		};
		return Fetch.fetch2<GetMetaProductsWithItemsResponse>(config);
	},

	GetMetaProductGroupingInformation: (
		body: GetMetaProductGroupingInformationPostBody
	) => {
		const uri = `/api/v4/metaproducts/group/info`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<GetMetaProductGroupingInformationResponse>(config);
	},

	UpsertMetaProductGroupings: (body: UpsertMetaProductGroupingsPostBody) => {
		const uri = `/api/v4/metaproducts/group/upsert`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<UpsertGroupingsResponse>(config);
	},

	CalculateCurrentMetaProductCoverages: (
		args: CalculateCurrentMetaProductCoveragesArgs
	) => {
		const uri = `/api/v4/metaproducts/calculatecurrentcoverages`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<CalculateCurrentMetaProductCoveragesResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const MetaProductGroupingController = {
	Regroup: (body: GenerateGroupingRecommendationRequest) => {
		const uri = `/api/v4/metaproductgrouping/regroup`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<GenerateGroupingRecommendationResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ZendeskController = {
	GetZendeskToken: (custContNum: string) => {
		const uri = `/api/v4/zendesk/?custContNum=${custContNum}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<ZendeskResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const BlueprintControllerV3 = {
	Get: (
		PageSize: number,
		PageIndex: number,
		SupplierId: number,
		SearchTerm: string
	) => {
		const uri = `/api/v3/masterorderguides/_actions/getBlueprints?PageSize=${PageSize}&PageIndex=${PageIndex}&SupplierId=${SupplierId}&SearchTerm=${SearchTerm}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<ResultSet<BlueprintListing>>(config);
	},

	GetDistributionCenterInfo: (blueprintId: number) => {
		const uri = `/api/v3/masterorderguides/${blueprintId}/distributioncenterinfo`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetDistributionCenterInfoResult>(config);
	},

	GetBlueprintDefaultMetaProductMaintainedBy: (blueprintId: number) => {
		const uri = `/api/v3/masterorderguides/${blueprintId}/defaultMaintainedBy?blueprintId=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetBlueprintDefaultMetaProductMaintainedByResult>(
			config
		);
	},

	GetByPost: (args: GetBlueprintsRequest) => {
		const uri = `/api/v3/masterorderguides/_actions/getBlueprints`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<ResultSet<BlueprintListing>>(config);
	},

	GetNumberOfBlueprintsContainingProducts: (
		supplierGroups: SupplierGroupArgs[]
	) => {
		const uri = `/api/v3/masterorderguides/_actions/getnumberofblueprintscontainingproducts`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(supplierGroups),
		};
		return Fetch.fetch2<GetNumberOfBlueprintsContainingProductsResult>(config);
	},

	GetBlueprintsProductIsOnForCustomer: (
		args: GetBlueprintsProductIsOnForCustomerRequest
	) => {
		const uri = `/api/v3/masterorderguides/_actions/getblueprintsproductisonforcustomer`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetBlueprintsProductIsOnForCustomerResult>(config);
	},

	SetActiveLocationsV3: (
		blueprintId: number,
		locationIds: ChangedLocations
	) => {
		const uri = `/api/v3/masterorderguides/${blueprintId}/activelocations?blueprintId=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'PUT',
			body: JSON.stringify(locationIds),
		};
		return Fetch.fetch2<void | void>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const CustomCategoryController = {
	GetCustomCategoriesForCustomer: () => {
		const uri = `/api/v3/customcategories/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<CustomCategory[]>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const CustomerControllerV3 = {
	Get: (customerId: number) => {
		const uri = `/api/v3/customers/${customerId}?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<CustomerAdminListing>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const CustomerItemNumbersController = {
	UpsertCustomerItemNumbers: (args: UpdateCustomerItemNumbersRequestObject) => {
		const uri = `/api/v3/customer-item-numbers/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<UpdateCustomerItemNumbersResult>(config);
	},

	GetCustomerItemNumberInfo: (args: GetCustomerItemNumberInfoRequestObject) => {
		const uri = `/api/v3/customer-item-numbers/get-single-product-information`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetCustomerItemNumberInfoResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const DiscontinuedAlertsController = {
	Get: (
		supplierId: number,
		filterType: string,
		filterValue: string,
		sortType: string,
		sortOrder: string,
		pageIndex: number,
		pageSize: number
	) => {
		const uri = `/api/v3/discontinuedalerts/?supplierId=${supplierId}&filterType=${filterType}&filterValue=${filterValue}&sortType=${sortType}&sortOrder=${sortOrder}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetDiscontinuedAlertsResult>(config);
	},

	BulkDelete: (args: BulkDeleteDiscontinuedAlertsArgs) => {
		const uri = `/api/v3/discontinuedalerts/bulkdelete`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DeleteDiscontinuedAlertsResult>(config);
	},

	FilteredDelete: (
		supplierId: number,
		filterType: string,
		filterValue: string
	) => {
		const uri = `/api/v3/discontinuedalerts/filtereddelete?supplierId=${supplierId}&filterType=${filterType}&filterValue=${filterValue}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'DELETE',
		};
		return Fetch.fetch2<DeleteDiscontinuedAlertsResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const GeneralLedgerController = {
	GetGlGroups: () => {
		const uri = `/api/v3/gls/_actions/getglgroups`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetGlGroupsResult | GetGlGroupsErrorResult>(config);
	},

	GetGlAccountsForGlGroup: (
		glGroupId: number,
		skip: number | null,
		take: number | null
	) => {
		const uri = `/api/v3/gls/glgroups/${glGroupId}?skip=${skip ?? ''}&take=${
			take ?? ''
		}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<
			GetGlAccountsForGlGroupResult | GetGlAccountsForGlGroupErrorResult
		>(config);
	},

	GetGlGroupsForProducts: (args: GetGlGroupsForProductsArgs) => {
		const uri = `/api/v3/gls/_actions/getglgroupsforproducts`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetGlGroupsForProductsResult>(config);
	},

	AssignGlAccount: (args: AssignGLAccountArgs) => {
		const uri = `/api/v3/gls/_actions/AssignGLAccount`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<string | AssignGlGroupErrorResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const LocationControllerV3 = {
	GetLocationsForBlueprint: (
		blueprintId: number,
		state: string,
		cityName: string,
		dcName: string,
		dcCode: string,
		searchValue: string,
		assignmentStatus: boolean | null,
		skip: number | null,
		take: number | null
	) => {
		const uri = `/api/v3/masterorderguides/${blueprintId}/locations?state=${state}&cityName=${cityName}&dcName=${dcName}&dcCode=${dcCode}&searchValue=${searchValue}&assignmentStatus=${
			assignmentStatus ?? ''
		}&skip=${skip ?? ''}&take=${take ?? ''}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<LocationAndFilterResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const MetaProductController = {
	AcceptMetaProductGroup: (body: AcceptMetaProductGroupPostBody) => {
		const uri = `/api/v3/metaproducts/group/accept`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<boolean>(config);
	},

	AcceptAllMetaProductGroup: (body: AcceptAllMetaProductGroupPostBody) => {
		const uri = `/api/v3/metaproducts/group/acceptall`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<boolean>(config);
	},

	StageMetaProductGroup: (body: StageMetaProductGroupPostBody) => {
		const uri = `/api/v3/metaproducts/group/stage`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<boolean>(config);
	},

	GetMetaProductGroups: (body: GetMetaProductGroupsPostBody) => {
		const uri = `/api/v3/metaproducts/groups`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<GetMetaProductGroupingsResponse>(config);
	},

	DeleteMetaProducts: (args: DeleteMetaProductsArgs) => {
		const uri = `/api/v3/delete-metaproducts`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DeleteMetaProductsResult>(config);
	},

	DeleteMetaProductByBPID: (args: DeleteMetaProductArgs) => {
		const uri = `/api/v3/metaproduct/delete-metaproduct`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DeleteMetaProductResult>(config);
	},

	SearchMetaProductGroupings: (args: SearchMetaProductGroupingArgsV6) => {
		const uri = `/api/v3/metaproducts/group/search`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<MetaProductGroupingResult>(config);
	},

	GetMetaProductChoicesGivenProductsAndSelectionRuleSet: (
		request: GetMetaProductChoicesGivenProductsAndSelectionRuleSetRequest
	) => {
		const uri = `/api/v3/metaproducts/choices`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(request),
		};
		return Fetch.fetch2<GetMetaProductChoicesGivenProductsAndRuleSetResponse>(
			config
		);
	},

	EditMetaProductsCategory: (
		metaProductInfo: MetaProductsCustomCategoryPostBody
	) => {
		const uri = `/api/v3/metaproducts/_actions/setcustomcategory`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(metaProductInfo),
		};
		return Fetch.fetch2<void>(config);
	},

	EditMetaProductsMaintainedBy: (body: MetaProductsMaintainedByPostBody) => {
		const uri = `/api/v3/metaproducts/_actions/setmaintainedby`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'PUT',
			body: JSON.stringify(body),
		};
		return Fetch.fetch2<void>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const OptimizationHistoryController = {
	GetAIHistory: (args: GetAIHistoryRequest) => {
		const uri = `/api/v3/optimizationhistory/search`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetAIHistoryResults>(config);
	},

	GetAIHistoryFilters: (args: GetAIHistoryFiltersRequest) => {
		const uri = `/api/v3/optimizationhistory/filters`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetAIHistoryFiltersResult>(config);
	},

	DeleteAIHistory: (histId: number, histType: HistoryType) => {
		const uri = `/api/v3/optimizationhistory/${histId}/${histType}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'DELETE',
		};
		return Fetch.fetch2<DeleteAIHistoryResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const OptimizationSuggestionController = {
	GetOptimizationSavings: () => {
		const uri = `/api/v3/optimizationsuggestion/savings`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetOptimizationSavingsResult>(config);
	},

	GetOptimizationSuggestionFilters: () => {
		const uri = `/api/v3/optimizationsuggestion/filters`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetOptimizationSuggestionFiltersResult>(config);
	},

	GetInProgressRecalculation: (masterItemId: number) => {
		const uri = `/api/v3/optimizationsuggestion/recalculate/get/${masterItemId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<InProgressRecalculateOptimizationResult>(config);
	},

	GetOptimizationSuggestions: (args: GetOptimizationSuggestionsRequest) => {
		const uri = `/api/v3/optimizationsuggestion/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetOptimizationSuggestionsResult>(config);
	},

	GetOptimizationDetails: (args: GetOptimizationDetailsArgs) => {
		const uri = `/api/v3/optimizationsuggestion/details`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetOptimizationDetailsResult>(config);
	},

	ApplyOptimization: (args: ApplyOptimizationsRequest) => {
		const uri = `/api/v3/optimizationsuggestion/apply`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<ApplyOptimizationsResult>(config);
	},

	ApplyOptimizationByMasterItem: (args: ApplyOptimizationByMasterItemArgs) => {
		const uri = `/api/v3/optimizationsuggestion/apply/masteritem`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<ApplyOptimizationByMasterItemResult>(config);
	},

	StageOptimizationByMasterItem: (args: StageOptimizationByMasterItemArgs) => {
		const uri = `/api/v3/optimizationsuggestion/stage/masteritem`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<StageOptimizationByMasterItemResult>(config);
	},

	DeclineOptimizationByMasterItem: (
		args: DeclineOptimizationByMasterItemArgs
	) => {
		const uri = `/api/v3/optimizationsuggestion/decline/masteritem`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DeclineOptimizationByMasterItemResult>(config);
	},

	OverrideNetUnits: (args: OverrideNetUnitsArgs) => {
		const uri = `/api/v3/optimizationsuggestion/netunits/override`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<OverrideNetUnitsResult>(config);
	},

	UpdateOptimizationItemNetUnits: (
		args: UpdateOptimizationItemNetUnitsArgs
	) => {
		const uri = `/api/v3/optimizationsuggestion/items/netunits/update`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<UpdateOptimizationItemNetUnitsResult>(config);
	},

	RecalculateOptimization: (
		masterItemId: number,
		args: RecalculateOptimizationArgs
	) => {
		const uri = `/api/v3/optimizationsuggestion/recalculate/${masterItemId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RecalculateOptimizationResult>(config);
	},

	DeleteOptimization: (optId: number) => {
		const uri = `/api/v3/optimizationsuggestion/${optId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'DELETE',
		};
		return Fetch.fetch2<DeleteOptimizationResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const PriceController = {
	GetProductHeaderPrices: (blueprintId: number, productNumbers: string[]) => {
		const uri = `/api/v3/prices/headers?bpid=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumbers),
		};
		return Fetch.fetch2<ProductHeaderPricesResult>(config);
	},

	GetProductHeaderPricesAcrossSuppliers: (
		products: SupplierProductIdentifier[]
	) => {
		const uri = `/api/v3/prices/headers/multisupplier`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(products),
		};
		return Fetch.fetch2<ProductHeaderPricesResult>(config);
	},

	GetProductLinePrices: (blueprintId: number, productNumber: string) => {
		const uri = `/api/v3/prices/lines?bpid=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumber),
		};
		return Fetch.fetch2<ProductLinePrices[]>(config);
	},

	GetProductLinePricesForMultipleProducts: (
		blueprintId: number,
		productNumbers: string[]
	) => {
		const uri = `/api/v3/prices/lines/multipleproducts?bpid=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumbers),
		};
		return Fetch.fetch2<ProductLinePrices[]>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ProductController = {
	MassChangeHomePage: () => {
		const uri = `/api/v3/products/mass-change-home-page`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<MassChangeHomeResult>(config);
	},

	GetMassChangePageData: () => {
		const uri = `/api/v3/products/mass-change-page-data`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetProductInputPageDataResult>(config);
	},

	VerifyProducts: (args: VerifyProductsArgs) => {
		const uri = `/api/v3/products/verify-products`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<VerifyProductsResult>(config);
	},

	SelectMasterOrderGuidesData: (args: SelectMasterOrderGuidesDataArgs) => {
		const uri = `/api/v3/products/select-master-order-guides-data`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<SelectMasterOrderGuidesDataResult>(config);
	},

	SelectBlueprintsDataMultSuppliers: (
		args: SelectBlueprintsDataMultSuppliersArgs
	) => {
		const uri = `/api/v3/products/select-blueprints-data-mult-suppliers`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<SelectMasterOrderGuidesDataResult>(config);
	},

	ReviewChanges: (args: ReviewChangesArgs) => {
		const uri = `/api/v3/products/review-changes`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<ReviewChangesResult>(config);
	},

	PollRequestStatus: (args: PollRequestStatusArgs) => {
		const uri = `/api/v3/products/poll-request-status`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<PollRequestStatusResult>(config);
	},

	ApplyChanges: (args: ApplyChangesArgs) => {
		const uri = `/api/v3/products/apply-changes`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<ApplyChangesResult>(config);
	},

	DiscardChanges: (args: DiscardChangesArgs) => {
		const uri = `/api/v3/products/discard-changes`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DiscardChangesResult>(config);
	},

	GetProductsByProductNumbersAnyStatus: (
		supplierId: number,
		productNumbers: string[]
	) => {
		const uri = `/api/v3/products/lookup-any-status?sid=${supplierId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumbers),
		};
		return Fetch.fetch2<LookupResult>(config);
	},

	GetProductLines: (blueprintId: number, productNumbers: string[]) => {
		const uri = `/api/v3/products/lines?bpid=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumbers),
		};
		return Fetch.fetch2<GetProductLinesResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ProductDetailsController = {
	GetProductDetails: (supplierCode: string, productNumber: string) => {
		const uri = `/api/v3/productdetails?supplierCode=${supplierCode}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(productNumber),
		};
		return Fetch.fetch2<ProductDetails>(config);
	},

	GetNutritionalInformation: (args: GetProductNutritionalInformationParams) => {
		const uri = `/api/v3/productdetails/nutrition`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<NutritionResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ProductUsageController = {
	GetProductUsageHistory: (args: GetProductUsageArgs) => {
		const uri = `/api/v3/productusage/usagehistory`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetProductUsageResult | GetProductUsageErrorResult>(
			config
		);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ReportController = {
	GetCustomerReports: (
		customerId: number,
		pageIndex: number,
		pageSize: number
	) => {
		const uri = `/api/v3/report/customer-reports?customerId=${customerId}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetGeneratedReportsResult>(config, true);
	},

	GetRequestableReports: (customerId: number) => {
		const uri = `/api/v3/report/customer-requestable-reports?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetRequestableReportsResult>(config, true);
	},

	IsLocationLevelPricingEnabled: (supplierId: number) => {
		const uri = `/api/v3/report/facilitypricing/${supplierId}/canrequest`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<IsLocationLevelPricingEnabledResponse>(config);
	},

	RequestOrderGuideReport: (args: RequestOrderGuideReportArgs) => {
		const uri = `/api/v3/report/request-order-guide-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOrderGuideReportResult>(config);
	},

	RequestStockMatrixReport: (args: RequestStockMatrixReportArgs) => {
		const uri = `/api/v3/report/request-stock-matrix-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestStockMatrixReportResult>(config);
	},

	RequestOgmAiHistoryReport: (args: RequestOgmAiHistoryReportArgs) => {
		const uri = `/api/v3/report/request-ogmai-history-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOgmAiHistoryReportResult>(config);
	},

	RequestOgmAiOptimizationsReport: (
		args: RequestOgmAiOptimizationsReportArgs
	) => {
		const uri = `/api/v3/report/request-ogmai-optimizations-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOgmAiOptimizationsReportResult>(config);
	},

	RequestOgmAiGroupingsReport: (args: RequestOgmAiGroupingsReportArgs) => {
		const uri = `/api/v3/report/request-ogmai-groupings-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOgmAiGroupingsReportResult>(config);
	},

	RequestOgmAiCombinedReport: (args: RequestOgmAiCombinedReportArgs) => {
		const uri = `/api/v3/report/request-ogmai-combined-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOgmAiCombinedReportResult>(config);
	},

	NewReportRequest: (args: NewReportRequestArgs) => {
		const uri = `/api/v3/report/new-report-request`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<NewReportRequestResult>(config);
	},

	RequestLocationLevelPricingReport: (
		args: RequestLocationLevelPricingReportArgs
	) => {
		const uri = `/api/v3/report/request-location-level-pricing-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestLocationLevelPricingReportResult>(config);
	},

	RequestCustomerItemNumberMappingsReport: () => {
		const uri = `/api/v3/report/customer-item-number-mappings`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
		};
		return Fetch.fetch2<RequestLocationLevelPricingReportResult>(config);
	},

	RequestOffOrderGuideSavingsReport: (
		args: RequestOffOrderGuideSavingsReportArgs
	) => {
		const uri = `/api/v3/report/request-off-order-guide-savings-report`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RequestOffOrderGuideSavingsReportResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const RestrictionsController = {
	GetRestrictionListing: (pageSize: number, pageIndex: number) => {
		const uri = `/api/v3/restrictions/listing?pageSize=${pageSize}&pageIndex=${pageIndex}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetRestrictionListingResult>(config);
	},

	GetNewListPageData: () => {
		const uri = `/api/v3/restrictions/new`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetNewListPageDataResult>(config);
	},

	GetRestrictionList: (listId: number) => {
		const uri = `/api/v3/restrictions/?listId=${listId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetRestrictionListResult>(config);
	},

	GetCategoryRulesPageData: (listId: number) => {
		const uri = `/api/v3/restrictions/rulesPage?listId=${listId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetCategoryRulesPageDataResult>(config);
	},

	GetSubCategories: (categoryId: number) => {
		const uri = `/api/v3/restrictions/subCategories?categoryId=${categoryId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetSubCategoriesResult>(config);
	},

	GetLocationListing: (restrictionListId: number) => {
		const uri = `/api/v3/restrictions/locationListing?restrictionListId=${restrictionListId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetLocationListingResult>(config);
	},

	CreateRestrictionList: (args: CreateRestrictionListArgs) => {
		const uri = `/api/v3/restrictions/createList`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<CreateRestrictionListResult>(config);
	},

	EditRestrictionList: (args: EditRestrictionListArgs) => {
		const uri = `/api/v3/restrictions/editList`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<EditRestrictionListResult>(config);
	},

	DeleteRestrictionList: (args: DeleteRestrictionListArgs) => {
		const uri = `/api/v3/restrictions/deleteList`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<DeleteRestrictionListResult>(config);
	},

	SaveCategoryRules: (args: SaveCategoryRulesArgs) => {
		const uri = `/api/v3/restrictions/saveCategoryRules`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<SaveCategoryRulesResult>(config);
	},

	UpdateRestrictionListLocationLinks: (
		args: UpdateRestrictionListLocationLinksArgs
	) => {
		const uri = `/api/v3/restrictions/updateRestrictionListLocationLinks`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<UpdateRestrictionListLocationLinksResult>(config);
	},

	GetItemRestrictionPage: (
		getItemRestrictionPageArgs: GetItemRestrictionPageArgs
	) => {
		const uri = `/api/v3/restrictions/item-restrictions`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(getItemRestrictionPageArgs),
		};
		return Fetch.fetch2<GetItemRestrictionPageResult>(config);
	},

	RemoveItemRestrictions: (args: RemoveItemRestrictionsArgs) => {
		const uri = `/api/v3/restrictions/remove-item-restrictions`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<RemoveItemRestrictionsResult>(config);
	},

	CheckProductNumbers: (args: CheckProductNumbersArgs) => {
		const uri = `/api/v3/restrictions/check-products`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<CheckProductNumbersResult>(config);
	},

	AddItemRestrictions: (args: AddItemRestrictionsArgs) => {
		const uri = `/api/v3/restrictions/add-item-restrictions`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<AddItemRestrictionsResult>(config);
	},

	GetNumberOfRestrictionListsContainingProducts: (
		args: GetNumberOfRestrictionListsContainingProductsArgs[]
	) => {
		const uri = `/api/v3/restrictions/_actions/getnumberofrestrictionlistscontainingproducts`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetNumberOfRestrictionListsContainingProductsResult>(
			config
		);
	},

	GetRestrictionListsProductIsOnForCustomer: (
		args: GetRestrictionListsProductIsOnForCustomerArgs
	) => {
		const uri = `/api/v3/restrictions/_actions/getrestrictionlistsproductisonforcustomer`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetRestrictionListsProductIsOnForCustomerResult>(
			config
		);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const SearchController = {
	Search: (args: SearchRequestObject) => {
		const uri = `/api/v3/search/search`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<SearchResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const SequenceController = {
	GetInvoiceSequencesForCustomer: (customerId: number) => {
		const uri = `/api/v3/invoiceSequences/?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetInvoiceSequenceForCustomerIdResult>(config);
	},

	CreateInvoiceSequence: (args: CreateInvoiceSequenceArgs) => {
		const uri = `/api/v3/invoiceSequences/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<CreateInvoiceSequenceResult>(config);
	},

	GetOrCreateInvoiceSequenceDraft: (invoiceSequenceId: number) => {
		const uri = `/api/v3/invoiceSequences/${invoiceSequenceId}/draft/getorcreate`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
		};
		return Fetch.fetch2<GetOrCreateInvoiceSequenceDraftResult>(config);
	},

	SubmitInvoiceSequenceDraft: (invoiceSequenceId: number, draftId: number) => {
		const uri = `/api/v3/invoiceSequences/${invoiceSequenceId}/draft/${draftId}/submit`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
		};
		return Fetch.fetch2<SubmitInvoiceSequenceDraftResult>(config);
	},

	UpdateAssociatedDistrubitonCenters: (
		invoiceSequenceId: number,
		args: UpdateDistributionCentersAssociatedToInvoiceSequenceArgs
	) => {
		const uri = `/api/v3/invoiceSequences/${invoiceSequenceId}/associatedDistributionCenters`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'PUT',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<UpdateAssociatedDistributionCentersResult>(config);
	},

	UpdateInvoiceSequenceDraft: (
		invoiceSequenceId: number,
		draftId: number,
		args: UpdateInvoiceSequenceDraftArgs
	) => {
		const uri = `/api/v3/invoiceSequences/${invoiceSequenceId}/draft/${draftId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'PUT',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<UpdateInvoiceSequenceDraftResult>(config);
	},

	DeleteInvoiceSequenceDraft: (invoiceSequenceId: number, draftId: number) => {
		const uri = `/api/v3/invoiceSequences/invoiceSequence/${invoiceSequenceId}/draft/${draftId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'DELETE',
		};
		return Fetch.fetch2<DeleteInvoiceSequenceDraftResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const SupplierCategoriesController = {
	GetTopLevelCategoriesForSupplier: (supplierId: number) => {
		const uri = `/api/v3/SupplierCategories/supplier/${supplierId}/categories`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetTopLevelCategoriesResult>(config);
	},

	GetSubCategories: (categoryId: number) => {
		const uri = `/api/v3/SupplierCategories/category/${categoryId}/subCategories`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetSubLevelCategoriesResult>(config);
	},

	GetCategoriesAndParentsByCategoryIds: (args: GetCategoryAndParentsArgs) => {
		const uri = `/api/v3/SupplierCategories/categoriesAndParents`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetCategoryAndParentsResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const SupplierControllerV3 = {
	GetSupplierByDssiCode: (dssiCode: string) => {
		const uri = `/api/v3/suppliers/${dssiCode}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<Supplier>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ManageCustomersController = {
	GetEditCustomerPage: (customerId: number) => {
		const uri = `/api/v3/syscoselfservice/customers/edit-customer-page?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetEditCustomerPageResult>(config);
	},

	SaveCustomerAttributes: (args: SaveCustomerAttributesArgs) => {
		const uri = `/api/v3/syscoselfservice/customers/save-customer-attrs`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<SaveCustomerAttributesResult>(config);
	},

	EnableCustomCategorySetting: (args: EnableCustomCategorySettingArgs) => {
		const uri = `/api/v3/syscoselfservice/customers/enable-custom-category`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<EnableCustomCategorySettingResult>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const ManageLocationsController = {
	GetLocationsForCustomer: (request: GetLocationsForCustomerRequest) => {
		const uri = `/api/v3/syscoselfservice/location/`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(request),
		};
		return Fetch.fetch2<ResultSet<LocationAdminListing>>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const BlueprintController = {
	GetById: (blueprintId: number) => {
		const uri = `/api/v2/masterorderguides/${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<BlueprintStatistics>(config);
	},

	DeleteBlueprint: (blueprintId: number) => {
		const uri = `/api/v2/masterorderguides/${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'DELETE',
		};
		return Fetch.fetch2<void>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const BlueprintDistributionCenterController = {
	GetBlueprintDistributionCenterLinksForCustomerAndMultipleSuppliers: (
		args: GetBlueprintDistributionCenterLinkForCustomerAndMultipleSuppliersArgs
	) => {
		const uri = `/api/v2/customer/BlueprintDistributionCenterLinks`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetBlueprintDistributionCenterLinkForCustomerAndMultipleSuppliersResponse>(
			config
		);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const CustomerController = {
	GetCustomersAssignedToUser: () => {
		const uri = `/api/v2/customers`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<Customer[]>(config);
	},

	GetCustomerNoteForCustomer: (customerId: number) => {
		const uri = `/api/v2/customers/${customerId}/note`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetCustomerNoteResults>(config);
	},

	UpdateCustomerNoteForCustomer: (
		customerId: number,
		args: UpdateCustomerNoteArgs
	) => {
		const uri = `/api/v2/?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetCustomerNoteResults>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const LocationDistributionCenterController = {
	GetCustomerSupplierDistributionCenterDssiCodes: (
		customerId: number,
		supplierId: number
	) => {
		const uri = `/api/v2/customer/${customerId}/supplierdssicodes/${supplierId}?customerId=${customerId}&supplierId=${supplierId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<GetDistributionCenterCodesForSupplierResponse>(config);
	},

	GetLocationsForCustomerAndMultipleSuppliers: (
		args: GetLocationsForCustomerAndMultipleSuppliersArgs
	) => {
		const uri = `/api/v2/customer/LocationsForCustomerAndMultipleSuppliers`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetLocationsForCustomerAndMultipleSuppliersResponse>(
			config
		);
	},

	GetDistributionCentersByDssiCodes: (
		args: GetDistributionCentersByDssiCodesArgs
	) => {
		const uri = `/api/v2/customer/GetDistributionCentersByDssiCode`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<GetDistributionCentersByDssiCodesResponse>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const SupplierController = {
	GetSuppliersByCustomer: (customerId: number) => {
		const uri = `/api/v2/suppliers/?customerId=${customerId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<Supplier[]>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const GetUSFoodsProductAttributesV1 = {
	GetUsFoodsProductAttributes: (args: GetUSFoodsProductAttributesArgs) => {
		const uri = `/api/v1/getUSFoodsProductAttributes`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(args),
		};
		return Fetch.fetch2<USFoodsProductAttributes[]>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const GetActiveLocationsForBlueprintV1 = {
	GetActiveLocationsForBlueprint: (blueprintId: number) => {
		const uri = `/api/v1/getActiveLocationsForBlueprint/${blueprintId}?blueprintId=${blueprintId}`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'GET',
		};
		return Fetch.fetch2<EnabledLocation[]>(config);
	},
};

// ==============================================
// This file is autogenerated.
// Manual changes made to this file will be lost.
// To update this file, run the Generator csproj.
// ==============================================
export const DeleteSyscoLocationsV1 = {
	DeleteSyscoLocations: (request: DeleteSyscoLocationsRequest) => {
		const uri = `/api/v1/deleteSyscoLocations`;
		const config: Fetch.RequestConfig = {
			uri,
			method: 'POST',
			body: JSON.stringify(request),
		};
		return Fetch.fetch2<boolean>(config);
	},
};
